import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Select wallet address' },
  selectCaption: { defaultMessage: 'Select HD derivation path' },
  addressesCaption: { defaultMessage: 'Select the address you would like to use' },

  selectButtonText: { defaultMessage: 'select' },
});
